export function activeButtonNav(nav, tag, pathname) {
    const ButtonsInNav = document.getElementById(nav);
    if (!ButtonsInNav) return;

    const AnchorInNav = Array.from(ButtonsInNav.getElementsByTagName(tag));

    const regexDocuments = /^\/?.?(documents|document-category)(\/.*)?$/;
    const regexNews = /^\/?.?news(\/.*)?$/;
    const regexProfile = /^\/?.?profile(\/.*)?$/;
    const regexNotifications = /^\/?.?notifications(\/.*)?$/;

    AnchorInNav.forEach((element) => {
        const dataId = element.dataset.id;

        if (
            dataId &&
            (pathname === '' && dataId === 'home' ||
                dataId === pathname ||
                (regexDocuments.test(pathname) && regexDocuments.test(dataId)) ||
                (regexNews.test(pathname) && regexNews.test(dataId)) ||
                (regexNotifications.test(pathname) && regexNotifications.test(dataId)) ||
                (regexProfile.test(pathname) && regexProfile.test(dataId)))
        ) {
            element.classList.add('active');
        } else {
            element.classList.remove('active');
        }
    });
}
